export const timestampFormat = (timestamp, format) => {
    let date = new Date(timestamp);
    if (!format) {
        format = "yyyy-MM-dd hh:mm:ss"
    }
    let week = {
        0: '周日',
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
    }
    let o = {
        "Y+": date.getFullYear(), //年份
        "M+": (date.getMonth() + 1) >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1), //月份
        "d+": date.getDate() >= 10 ? date.getDate() : '0' + date.getDate(), //日
        "h+": date.getHours() >= 10 ? date.getHours() : '0' + date.getHours(), //时
        "m+": date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes(), //分
        "s+": date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds(), //millisecond
        "w+": week[date.getDay()]
    }

    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (let k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}

export const formatSeconds = (ms) => {
    let seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    let timeString = "";
    if (hours > 0) {
        timeString += `${hours}小时`;
    }
    if (minutes > 0 || hours > 0) {
        timeString += `${minutes}分钟`;
    }
    timeString += `${seconds}秒`;

    return timeString;
}